import getIsJunkValueToSet from 'mini-mail-triage-actions/lib/utils/markAsJunk/getIsJunkValueToSet';
import strings from 'owa-strings/owa-mini-strings';
import {
    getIsAnySelectedUnflagged,
    getIsAnySelectedUnread,
} from 'mini-mail-list-store/lib/utils/getTriageState';
import { format } from 'owa-strings';
import getSelectedMailListItems from 'mini-mail-list-store/lib/utils/getSelectedMailListItems';

/**
 * Returns the totalNumberOfSelectedMailListItems and isMoreThanOneItemSelected values
 */
const getSelectedItemsInfo = () => {
    const totalNumberOfSelectedMailListItems = getSelectedMailListItems().length;
    return {
        totalNumberOfSelectedMailListItems,
        isMoreThanOneItemSelected: totalNumberOfSelectedMailListItems > 1,
    };
};

/**
 * Returns the markAsJunkAriaLabel string
 */
export const getMarkAsJunkAriaLabel = () => {
    const {
        isMoreThanOneItemSelected,
        totalNumberOfSelectedMailListItems,
    } = getSelectedItemsInfo();

    let markAsJunkAriaLabel: string;

    if (getIsJunkValueToSet()) {
        // Junk the mail
        markAsJunkAriaLabel = isMoreThanOneItemSelected
            ? format(
                  strings.markAsJunkMultipleMessagesAriaLabel,
                  totalNumberOfSelectedMailListItems
              )
            : strings.markAsJunkSingleMessageAriaLabel;
    } else {
        // Unjunk the mail
        markAsJunkAriaLabel = isMoreThanOneItemSelected
            ? format(
                  strings.markAsUnjunkMultipleMessagesAriaLabel,
                  totalNumberOfSelectedMailListItems
              )
            : strings.markAsUnjunkSingleMessageAriaLabel;
    }

    return markAsJunkAriaLabel;
};

/**
 * Returns the markAsFlaggedAriaLabel string
 */
export const getMarkAsFlaggedAriaLabel = () => {
    const {
        isMoreThanOneItemSelected,
        totalNumberOfSelectedMailListItems,
    } = getSelectedItemsInfo();

    let markAsFlaggedAriaLabel: string;

    if (getIsAnySelectedUnflagged()) {
        markAsFlaggedAriaLabel = isMoreThanOneItemSelected
            ? format(
                  strings.markAsFlaggedMultipleMessagesAriaLabel,
                  totalNumberOfSelectedMailListItems
              )
            : strings.markAsFlaggedSingleMessageAriaLabel;
    } else {
        markAsFlaggedAriaLabel = isMoreThanOneItemSelected
            ? format(
                  strings.markAsUnflaggedMultipleMessagesAriaLabel,
                  totalNumberOfSelectedMailListItems
              )
            : strings.markAsUnflaggedSingleMessageAriaLabel;
    }

    return markAsFlaggedAriaLabel;
};

/**
 * Returns the markAsReadAriaLabel string
 */
export const getMarkAsReadAriaLabel = () => {
    const {
        isMoreThanOneItemSelected,
        totalNumberOfSelectedMailListItems,
    } = getSelectedItemsInfo();

    let markAsReadAriaLabel: string;

    if (getIsAnySelectedUnread()) {
        markAsReadAriaLabel = isMoreThanOneItemSelected
            ? format(
                  strings.markAsReadMultipleMessagesAriaLabel,
                  totalNumberOfSelectedMailListItems
              )
            : strings.markAsReadSingleMessageAriaLabel;
    } else {
        markAsReadAriaLabel = isMoreThanOneItemSelected
            ? format(
                  strings.markAsUnreadMultipleMessagesAriaLabel,
                  totalNumberOfSelectedMailListItems
              )
            : strings.markAsUnreadSingleMessageAriaLabel;
    }

    return markAsReadAriaLabel;
};

/**
 * Returns the deleteAriaLabel string
 */
export const getDeleteAriaLabel = () => {
    const {
        isMoreThanOneItemSelected,
        totalNumberOfSelectedMailListItems,
    } = getSelectedItemsInfo();

    return isMoreThanOneItemSelected
        ? format(strings.deleteMultipleMessagesAriaLabel, totalNumberOfSelectedMailListItems)
        : strings.deleteSingleMessageAriaLabel;
};

/**
 * Returns the moveToFolderAriaLabel string
 */
export const getMoveToFolderAriaLabel = () => {
    const {
        isMoreThanOneItemSelected,
        totalNumberOfSelectedMailListItems,
    } = getSelectedItemsInfo();

    return isMoreThanOneItemSelected
        ? format(strings.moveToFolderMultipleMessagesAriaLabel, totalNumberOfSelectedMailListItems)
        : strings.moveToFolderSingleMessageAriaLabel;
};
